import React from 'react';
import { Tag } from 'antd';

export default function Status({ status }: { status: string }) {
  const statusSelector = (status: string) => {
    switch (status) {
      case 'done':
        return <Tag color="#92D1BA">Done</Tag>;
      case 'todo':
        return <Tag color="#B0DAF8">To do</Tag>;
      case 'in_progress':
        return <Tag color="#FAECCC">In progress</Tag>;
      case 'blocked':
        return <Tag color="#F5C8BE">Blocked</Tag>;
      default:
        return null;
    }
  };

  return (
    <span className="status_container">
      {statusSelector(status === 'stuck' ? 'blocked' : status)}
    </span>
  );
}
